import { object } from 'yup';

import { createAdsCampaignOrderStore } from 'stores/createAdsCampaignOrderStore';
import { getCaseAssetsApi } from 'api/cases/query';
import { useCallback, useMemo, useState } from 'react';
import { ISimplifiedVisualMaterial } from 'api';
import { MODAL_ID, MODALS_STORE } from 'constants/ui/modal';
import { getMediaType } from 'utils/getMediaType';

const MAX_SELECTED = 4;

export const useCreateAdsCampaignOrderStep3 = () => {
  const [materials, setMaterials] = useState<ISimplifiedVisualMaterial[]>([]);
  const { toggleModal, getModalData, isModalOpen } = MODALS_STORE.createOrder(state => state);
  const currentOpeningFile = getModalData(MODAL_ID.ORDER_SHOW_MATERIAL)?.assets?.activeIndex;

  const { goToStep } = createAdsCampaignOrderStore();

  const formSchema = object().shape({});

  const { data, isLoading } = getCaseAssetsApi('93f02773-dfcf-462b-a37c-69cb250beda8');
  const handleNextStep = () => {
    goToStep(4);
  };

  const handleChooseImages = useCallback((asset: ISimplifiedVisualMaterial) => {
    setMaterials(prev => {
      const hasChosen = prev.some(a => String(a.id) === String(asset.id));
      if (hasChosen) return prev.filter(a => String(a.id) !== String(asset.id));
      if (prev.length >= MAX_SELECTED) return prev;
      return [...prev, asset];
    });
  }, []);

  const handleRemoveImage = useCallback((id: string) => {
    setMaterials(prev => prev.filter(a => String(a.id) !== String(id)));
  }, []);

  const handleShowMaterial = useCallback((id: string) => {
    const currentImgIndex = materials.findIndex(item => +item.id === +id);
    toggleModal(MODAL_ID.ORDER_SHOW_MATERIAL, {
      assets: {
        activeIndex: currentImgIndex,
      },
    });
  }, []);

  const transformMediaProperties = useMemo(() => {
    if (materials.length) {
      return materials.map(material => ({
        url: material.source ?? '',
        type: material.source ? getMediaType({ url: material.source }) : undefined,
        title: material.fileName ?? '',
      }));
    }
  }, [materials]);

  return {
    form: { schema: formSchema },
    apiStates: { data, isLoading },
    clientStates: {
      materials,
      currentOpeningFile,
      isOpenAsset: isModalOpen(MODAL_ID.ORDER_SHOW_MATERIAL),
      transformMediaProperties,
    },
    actions: {
      handleNextStep,
      handleChooseImages,
      handleRemoveImage,
      handleShowMaterial,
      closeViewMaterial: () => toggleModal(MODAL_ID.ORDER_SHOW_MATERIAL),
    },
  };
};
